import { FormElement } from './form-element.model';
import { FormElementSummary } from './form-element-summary.model';

export class FormElementCheckBox extends FormElement {
  public constructor() {
    super();

    this.intialize();
  }

  public intialize = (): void => {
    this.Value = false;
    this.ElementTypeId = 2;
    this.IsMutuallyExclusive = false;
    this.MutuallyExclusiveFormElements = new Array<FormElementSummary>();
  };

  public Value: boolean;
  public MutuallyExclusiveFormElements: Array<FormElementSummary>;
  public IsMutuallyExclusive: boolean;
}
